import { apiService } from "src/services";
import { IResponse } from "src/pages/Studies/models/interfaces";
import { IProfileContextResponse, IUpdateProfileContextPayload } from "../models/interface";

export const getProfileContext = () => {
	return apiService.get("/masters/profile-context");
};

export const updateProfileContext = (payload: IUpdateProfileContextPayload) => {
	return apiService.put("/masters/profile-context", payload);
};
